import { observer } from "mobx-react"
import { TextField, Box, useTheme, Typography } from "@mui/material"
import { t } from "@lingui/macro"

import { EditProductStore } from "src/views/product-catalogue/edit/store"
import { useStore } from "src/store/lib/useStore"
import { Alert16 } from "src/components/icons/Alert16"
import { Icon } from "src/components/icons"
import { Tooltip } from "src/components/Tooltips/Tooltip"

export const OrderDeliveryProcess = observer(() => {
    const store = useStore(EditProductStore)
    const theme = useTheme()
    const productType = store.formFields.get("productType")

    return (
        <div>
            <Box
                sx={{ display: "flex", alignItems: "center", gap: "8px" }}
                style={{ breakInside: "avoid" }}
            >
                <div>
                    <Typography component="h3" fontSize="14px" fontWeight="700">
                        {productType === "standard_improvement_single"
                            ? t`edit-product-view.the-process.label`
                            : t`edit-product-view.order-delivery-process.label`}
                    </Typography>
                    <Typography fontSize="14px">
                        {t`edit-product-view.order-delivery-process.description`}
                    </Typography>
                </div>
                <Tooltip
                    title={t`edit-product-view.order-delivery-process.tooltip`}
                    arrow
                >
                    <Typography sx={{ lineHeight: 0 }}>
                        <Icon
                            icon={<Alert16 width="20px" height="20px" />}
                            color={theme.palette.grey[700]}
                        />
                    </Typography>
                </Tooltip>
            </Box>
            <TextField
                label={
                    productType === "standard_improvement_single"
                        ? t`edit-product-view.the-process.label`
                        : t`edit-product-view.order-delivery-process.label`
                }
                multiline
                rows={6}
                value={store.formFields.get("orderDeliveryProcess") ?? ""}
                helperText={
                    store.formFields.error("orderDeliveryProcess") ??
                    t`edit-product-view.order-delivery-process.helper`
                }
                onChange={store.formFields.setter("orderDeliveryProcess")}
                sx={{ mt: 2.5 }}
                error={Boolean(store.formFields.error("orderDeliveryProcess"))}
            />
        </div>
    )
})
